export function isProcedureCarousel(node: Elvita.Topic, data: string) {
  return (
    node.parent.attribs.class === 'task' &&
    node.attribs.class.includes('steps') &&
    data.indexOf('<div class="step-info">') > 0
  );
}

export function getProcedureCarouselData(
  node: Elvita.Topic,
  data: string,
): { data: Elvita.StepData[]; id: string } | null {
  if (!isProcedureCarousel(node, data) || !node.children) {
    return null;
  }

  const items: Elvita.StepData[] = [];
  const steps = node.children.filter(child =>
    child.attribs?.class?.includes('step'),
  );

  steps.forEach(step => {
    const info = step.children?.find(c =>
      c.attribs?.class?.includes('step-info'),
    );
    const figure = info?.children?.find(c =>
      c.attribs?.class?.includes('figure'),
    );
    const img = figure?.children?.find(i => i?.attribs?.src);

    if (!img?.attribs.src) return;

    const sub = data.substring(data.indexOf(step.attribs.id));
    const stepAction = sub.indexOf('<div class="step-action">');
    const stepInfo = sub.indexOf('<div class="step-info">');

    if (stepAction > 0 && stepInfo > 0) {
      items.push({
        id: img.attribs.src,
        node: img,
        data: sub.substring(stepAction, stepInfo),
      });
    }
  });

  if (items.length === 0) return null;

  return { data: items, id: items[0].id };
}

export function getMedialistCarouselData(node: Elvita.Topic): {
  items: Elvita.MedialistCarouselData[];
  id: string;
} | null {
  const divs =
    node.children?.filter(c => c.attribs?.class.includes('mli')) ?? [];

  const items = divs.flatMap(item => {
    const img = item.children?.find(c => c.name === 'img');
    if (!img?.attribs.src) return [];
    return [{ id: img.attribs.src, node: img }];
  });

  if (items.length === 0) return null;

  return { items, id: divs[0].attribs.id };
}
